<template>
  <div v-if="visible" class="full-frequency">
    <ncs-empty-result v-if="totalElements === 0"/>
    <div v-else class="container">
      <div class="row">
        <div v-for="group in groups" class="col-lg-12 p-1">
          <ncs-full-frequency-result-table :frequency-per-value="result[group]" :group="group"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue'
import { reduce } from 'lodash-es'
import { useNcsConfig, useApiStore, FullFrequencyResult } from 'ncs'

export default defineComponent({
  setup() {
    const ncsConfig = useNcsConfig()
    const apiStore = useApiStore()

    const groups = ncsConfig.queries.full_frequency.frequencyGroupOrder
    const result = computed(() => apiStore.response as FullFrequencyResult)
    const visible = computed(() => apiStore.query?.type === 'full_frequency')
    const totalElements = computed(() => reduce(result.value, (ga, g) => ga + reduce(g, (va, v) => va + v.elements, 0), 0))

    return {
      visible,
      groups,
      totalElements,
      result
    }
  }
})
</script>
